"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _recharts = require("recharts");

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CartesianGrid = (0, _mobxReact.observer)(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CartesianGrid, _Component);

  var _super = _createSuper(CartesianGrid);

  function CartesianGrid() {
    (0, _classCallCheck2["default"])(this, CartesianGrid);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CartesianGrid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, this.props);
    }
  }], [{
    key: "convertToRechartsProps",
    value: function convertToRechartsProps(props) {
      var verticalFill = props.verticalFill,
          rechartsProps = (0, _objectWithoutProperties2["default"])(props, ["verticalFill"]);
      var verticalFillColor = verticalFill ? verticalFill.map(function (highlight) {
        return highlight ? "white" : "#8bb1c1";
      }) : undefined;
      return _objectSpread(_objectSpread({}, rechartsProps), {}, {
        verticalFill: verticalFillColor
      });
    }
  }]);
  return CartesianGrid;
}(_react.Component), _class2.propDoc = {
  vertical: {
    required: true,
    type: "boolean",
    description: "if vertical grid lines for chart should be displayed"
  },
  horizontal: {
    required: true,
    type: "boolean",
    description: "if horizontal grid lines for chart should be displayed"
  },
  stroke: {
    required: false,
    type: "string",
    description: "color of grid lines"
  },
  fillOpacity: {
    required: false,
    type: "number",
    description: "fill opacity of grid"
  },
  verticalFill: {
    required: false,
    type: "ReadonlyArray<any>",
    description: "x axis data points that should be filled"
  }
}, _class2.defaultProps = {
  stroke: "#afc7d1",
  fillOpacity: 0.1
}, _temp)) || _class;

var _default = CartesianGrid;
exports["default"] = _default;